var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAExtraSidebar } from '../ancillaries/extra-sidebar.indra.abstract';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { EXTRAS_ANCILLARY_CARBON_OFFSET, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_ADD_CART, EVENT_PRODUCT_BRAND_CARBON_OFFSET, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
var INDRACarbonOffsetComponent = /** @class */ (function (_super) {
    __extends(INDRACarbonOffsetComponent, _super);
    function INDRACarbonOffsetComponent(sidebarService, route, router, store, indraBookingService, indraMybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, dateService, googleAnalytics, bfmStorage, ancillaryService, currencyService, storageService, currencyPipe, paymentInfoService) {
        var _this = _super.call(this, sidebarService, route, router, indraBookingService, indraMybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_CARBON_OFFSET, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService) || this;
        _this.sidebarService = sidebarService;
        _this.route = route;
        _this.router = router;
        _this.indraBookingService = indraBookingService;
        _this.indraMybService = indraMybService;
        _this.ibeAdminService = ibeAdminService;
        _this.ancillariesSelectionSrv = ancillariesSelectionSrv;
        _this.ancillariesShoppingCartSrv = ancillariesShoppingCartSrv;
        _this.dateService = dateService;
        _this.googleAnalytics = googleAnalytics;
        _this.bfmStorage = bfmStorage;
        _this.ancillaryService = ancillaryService;
        _this.currencyService = currencyService;
        _this.currencyPipe = currencyPipe;
        _this.paymentInfoService = paymentInfoService;
        _this.isAlive = true;
        _this.isLoading = false;
        _this.carbonOffsets = null;
        _this.showAddError = false;
        _this.showRemoveError = false;
        _this.isModificationDisallowed = false;
        var thirdPartyAncillaries = _this.bfmStorage.INDRA_getThirdPartyAncillaries();
        _this.booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
        var carbonOffset = thirdPartyAncillaries.find(function (bundle) {
            return bundle.ancillaryList[0].type == EXTRAS_ANCILLARY_CARBON_OFFSET;
        });
        if (carbonOffset) {
            _this.carbonOffsets = carbonOffset.carbonOffsetProperties;
            _this.currency = _this.currencyService.INDRA_getCurrencySymbol(_this.carbonOffsets.currency).unit;
        }
        _this.carbonOffset = _this.booked_trip.carbon_offset ? true : false;
        // get 'isBookingCreated' if existing in URL query params
        var isBookingCreatedParam = _this.route.snapshot.paramMap.get('isBookingCreated');
        if (isBookingCreatedParam === 'true') {
            _this.isModificationDisallowed = true;
        }
        return _this;
    }
    INDRACarbonOffsetComponent.prototype.ngOnInit = function () {
    };
    INDRACarbonOffsetComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRACarbonOffsetComponent.prototype.INDRA_handleClose = function () {
        this.sidebarService.closeSidebar();
    };
    INDRACarbonOffsetComponent.prototype.INDRA_carbonOffsetChanged = function () {
        var _this = this;
        this.isLoading = true;
        this.carbonOffset = !this.carbonOffset;
        this.indraBookingService.INDRA_setExtraChanged('carbon_offset', this.carbonOffset);
        // note: please create a model for the request
        if (!this.booked_trip.carbon_offset && this.carbonOffset) {
            var request = {
                'provider': 'CARBON_OFFSET',
                'idReservation': 'CO_001',
                'description': 'carbon offset',
                'currency': this.carbonOffsets.currency,
                'amount': this.carbonOffsets.totalForAllPassenger,
                'status': 'OK',
                'bookableItemId': 'CO_001',
                'extraInfo': {
                    'totalDistance': this.carbonOffsets.totalDistance,
                    'co2Emissions': this.carbonOffsets.co2Emissions,
                    'contributionPerPassenger': this.carbonOffsets.contributionPerPassenger,
                    'segmentPrices': this.carbonOffsets.segmentPrices,
                    'quoteId': this.carbonOffsets.quoteId,
                    "totalCost": this.carbonOffsets.totalCost,
                    "totalTax": this.carbonOffsets.totalTax,
                }
            };
            this.ancillaryService.INDRA_addExternalReservation(request, 'CARBON_OFFSET').subscribe(function (res) {
                if (res && res.status === '200' && res.reservations && res.reservations.CARBON_OFFSET) {
                    _this.isLoading = true;
                    var booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
                    booked_trip.carbon_offset = res.reservations.CARBON_OFFSET;
                    _this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
                    _this.INDRA_registerGA_carbonOffset();
                    _this.paymentInfoService.setUpdateBookingTotals(true);
                    _this.INDRA_handleClose();
                    _this.isLoading = false;
                }
                else {
                    _this.paymentInfoService.setUpdateBookingTotals(true);
                    _this.showAddError = true;
                    _this.isLoading = false;
                }
            }, function (error) {
                _this.paymentInfoService.setUpdateBookingTotals(true);
                if (error) {
                    _this.showAddError = true;
                    _this.isLoading = false;
                }
            });
        }
        else {
            this.ancillaryService.INDRA_removeExternalReservation('CARBON_OFFSET').subscribe(function (res) {
                if (res && res.status === '200') {
                    var booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
                    var bookedTripCarbonOffset = booked_trip.carbon_offset[0];
                    booked_trip.carbon_offset = null;
                    _this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
                    _this.paymentInfoService.setUpdateBookingTotals(true);
                    _this.INDRA_handleClose();
                    _this.isLoading = false;
                }
                else {
                    _this.paymentInfoService.setUpdateBookingTotals(true);
                    _this.showRemoveError = true;
                    _this.isLoading = false;
                }
            }, function (error) {
                _this.paymentInfoService.setUpdateBookingTotals(true);
                if (error) {
                    _this.showRemoveError = true;
                    _this.isLoading = false;
                }
            });
        }
    };
    INDRACarbonOffsetComponent.prototype.INDRA_registerGA_carbonOffset = function () {
        var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
        var eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CARBON_OFFSET, activeBooking.carbon_offset[0]);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
        this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRACarbonOffsetComponent.prototype.INDRA_removeGACarbonOffset = function (bookedTripCarbonOffset) {
        var eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CARBON_OFFSET, bookedTripCarbonOffset);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);
        this.googleAnalytics.INDRA_GA_removeFromCart(this.currency, eventDataLayerObject);
    };
    return INDRACarbonOffsetComponent;
}(INDRAExtraSidebar));
export { INDRACarbonOffsetComponent };
